import React from 'react';
import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DATE_PICKER_FORMAT } from '../../services/dates/dateService';

registerLocale('es', es);

export function CalendarDatePicker({
  selected,
  onChange,
  disabled = false,
  className = 'md-page__field-input',
  inputId,
  locale = 'es',
  closeOnScroll = true
}) {
  return (
    <DatePicker
      id={inputId}
      className={className}
      locale={locale}
      closeOnScroll={closeOnScroll}
      selected={selected}
      onChange={onChange}
      disabled={disabled}
      dateFormat={DATE_PICKER_FORMAT}
    />
  );
}
